<template>
  <v-main class="background-tcc login-register">
    <LoginDialog v-model="alertDialog.show" :message="alertDialog.message" :title="alertDialog.title" />
    <TermsDialog v-model="showModalTerms" v-on:update-terms="updateTerms" :terms="terms" />

    <ModalRegister 
      :isVisible="isVisible"
      :isSuccess="isSuccess"
      :message="registerMessage"
      @closeModalRegister="closeModalRegister"
    />
    <v-container class="pa-0" fill-height>
      <v-row justify="center">

        <v-col cols="12" style="display: flex; justify-content: center">
          <v-card class="elevation-10 main-card">
            <v-toolbar class="header-card elevation-0">
              <v-toolbar-title class="title-login">
                <RegisterIcon v-if="register" />
                <LoginIcon v-else />
                {{ register ? "REGISTRATE" : "BIENVENIDO" }}
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text class="card-text-auth">
              <v-form v-model="valid" ref="form" lazy-validation @submit="submit">
                <SocialButton :height="height" :register="register" @dataLayer="dataLayer"/>
                <v-row>
                  <v-col cols="12">
                    <h4 class="form-title text-uppercase text-center mt-5 mb-3">
                      {{
                          register
                            ? "o registrate utilizando tu correo electronico"
                            : "Ingresa con tu usuario y contraseña"
                      }}
                    </h4>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="text-center">
                    <v-text-field v-if="!register" v-model.lazy="email" placeholder="Usuario" solo
                      prepend-inner-icon="mdi-account" :rules="[rules.required, rules.email]" class="rounded-input custom-input-login" />

                    <v-text-field v-else v-model="email" placeholder="Email" prepend-inner-icon="mdi-email-outline" solo
                      :rules="[rules.required, rules.email]" class="rounded-input custom-input-login mb-5" />

                    <v-text-field v-if="register" v-model="name" placeholder="Nombre y apellido" solo
                      prepend-inner-icon="mdi-account" :rules="[rules.required, rules.noEdgeSpaces]" class="rounded-input custom-input-login mb-5" />

                    <v-text-field v-model="password" placeholder="Contraseña" solo prepend-inner-icon="mdi-lock"
                    :rules="register ? [rules.required, rules.strongPassword] : [rules.required]"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword"
                    class="rounded-input custom-input-login mb-5" :type="showPassword ? 'text' : 'password'" />

                    <v-text-field v-show="register" v-model="confirmPassword" placeholder="Confirmar Contraseña" solo
                      prepend-inner-icon="mdi-lock" :rules="[
                        rules.required,
                        (value) =>
                          password === value || 'Contraseña no coincide',
                      ]"
                      :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showConfirmPassword = !showConfirmPassword"
                      class="rounded-input custom-input-login mb-6" :type="showConfirmPassword ? 'text' : 'password'" />

                    <v-layout justify-center>
                      <VueRecaptcha @render="onRender" @verify="onVerify" @expired="onExpired" ref="recaptcha"
                        sitekey="6LdRjfIhAAAAABpxtpdkBk6iEUUrN9SF0PZf2MTq" />

                    </v-layout>
                    <small class="red--text font-weight-bold" v-if="captcha.error">Diligencia el captcha</small>

                    <v-layout justify-center v-if="register" @click="openModalTerms" class="check-terms">
                      <v-checkbox :value="terms" :rules="[rules.required]">
                        <template v-slot:label>
                          <p>
                            Acepto 
                            <strong>
                              terminos y condiciones y politica de tratamiento de datos
                            </strong>
                          </p>
                        </template>
                      </v-checkbox>
                      <div class="overlay-checkbox">

                      </div>
                    </v-layout>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-btn class="falkon-btn mt-1 mb-8" rounded block @click="submit" :loading="loading" :disabled="loading">
                      {{ register ? "Crear usuario" : "Ingresar" }}
                    </v-btn>
                  </v-col>
                  <v-col cols="12 pb-4">
                    <p class="label-register  ma-0">
                      {{
                          !register ? "¿Aún no eres usuario? " : "¿Ya eres usuario registrado? "
                      }}
                      <strong class=" label-pointer anchor-text" @click="toggleRegister">
                        {{ !register ? "Registrate" : " Ingresa" }}
                      </strong>
                    </p>
                  </v-col>

                  <v-col cols="12 pb-4 label-forgot-password" v-if="!register">
                    <strong @click="isOpenRecover = true" class="ml-1 label-pointer anchor-text">
                      ¿Olvidaste tu contraseña?
                    </strong>
                    <RecoverModal v-model="isOpenRecover" />
                  </v-col>
                </v-row>
                <!-- <ConditionPolicy /> -->
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { post } from "@/services/apiService";
import { mapState } from "vuex";
import SocialButton from "./SocialButton.vue";
//import ConditionPolicy from "../ConditionPolicy/ConditionPolicy.vue";
import VueRecaptcha from "vue-recaptcha";
import RecoverModal from "../RecoverPassword/RecoverModal.vue";
import LoginDialog from "../Login/LoginDialog.vue";
import ModalRegister from "../Messages/ModalRegister.vue";
import LoginIcon from "../Snippets/LoginIcon.vue";
import RegisterIcon from "../Snippets/RegisterIcon.vue";
import TermsDialog from "./TermsDialog.vue";
import moment from "moment";
import ipService from "../../services/ipservice";
import datalayerService from "../../services/datalayer";
import rules from "@/components/Validations.js";
import recaptchaLoader from "@/services/recaptchaLoader";

export default {
  components: { RecoverModal, SocialButton, VueRecaptcha, /* ConditionPolicy ,*/ LoginDialog, ModalRegister, LoginIcon, RegisterIcon, TermsDialog },
  data: () => ({
    rules,
    register: false,
    isVisible: false,
    isSuccess: false,
    email: "",
    name: "",
    password: "",
    confirmPassword: "",
    showPassword: false,
    showConfirmPassword: false,
    registerMessage: "",
    captcha: {
      id: null,
      value: null,
      error: false,
    },
    valid: true,
    errorDialog: {
      show: false,
      message: "",
    },
    loading: false,
    isOpenRecover: false,
    alertDialog: {
      show: false,
      message: '',
      error: false,
      title: ''
    },
    terms: false,
    showModalTerms: false,
    ipAddress: " "
  }),
  mounted() {
    if (this.isLoggedIn === true) {
      this.$router.push("/home");
      return;
    }

    if (this.registerParam === '1') {
      this.register = true;
    }

    // reCAPTCHA solo se usa en Login/Registro y en RecoverModal (hijo de esta vista, que
    // también dispara recaptchaLoader.inject() al abrirse, por si el usuario llega ahí
    // antes de este timer). El usuario tarda varios segundos en escribir sus credenciales
    // antes de necesitar el captcha, así que se retrasa para no competir por CPU con el
    // primer render del login. recaptchaLoader es idempotente: a salvo de remounts
    // (logout, sesión expirada) que antes re-inyectaban el script cada vez.
    setTimeout(recaptchaLoader.inject, 6000)
  },
  created () {
    ipService.getIpUser().then((res) => {
      this.ipAddress = res 
    })
  },
  computed: {
    ...mapState({
      isLoggedIn: (state) => state.auth.isLoggedIn,
      user: (state) => state.userProfile.userProfile
    }),
    height() {
      const heighComponent = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
          ? document.documentElement.clientHeight
          : screen.height;
      return heighComponent;
    },
    registerParam() {
      const url = window.location.search;
      const searchParams = new URLSearchParams(url);

      const r = searchParams.get('r');

      return r;
    },
  },
  methods: {
    updateTerms(state){
      this.terms = state;
    },
    openModalTerms() {
      this.showModalTerms = true;
    },
    async submit() {
      if (!this.$refs.form.validate() && this.register) {
        this.isVisible = true;
        this.isSuccess = false;
        return;
      }
      if (!this.email && !this.password && !this.register) return;
      if (!this.captcha.value) {
        this.captcha.error = true;
        return;
      }
      const dataSend = {
        email: this.email,
        password: this.password,
        name: this.name,
        recaptcha: this.captcha.value,
        ipAddress: this.ipAddress,
      };

      if(this.register && this.terms){
        let date = new moment().format("YYYY-MM-DD hh:mm a");
        let userAgent = window.navigator.userAgent;
        let operativeSystem = "desconocido";
        
        if (/Windows/.test(userAgent)) {
          operativeSystem = 'Windows';
        } else if (/Macintosh|Mac OS/.test(userAgent)) {
          operativeSystem = 'MacOS';
        } else if (/Android/.test(userAgent)) {
          operativeSystem = 'Android';
        } else if (/iOS/.test(userAgent)) {
          operativeSystem = 'iOS';
        } else if (/Linux/.test(userAgent)) {
          operativeSystem = 'Linux';
        }
        dataSend.acceptTermsAndConditions = true;
        dataSend.acceptDataPolicyTreatment = true;
        dataSend.acceptanceDate = date;
        dataSend.operativeSystem = operativeSystem;
        console.log('register'); //eslint-disable-line
        datalayerService.registerStep1(this.name);
      }

      this.loading = true;
      const response = this.register
        ? await post('channel/api/auth/register', dataSend)
        : await post('channel/api/auth/login', dataSend);
      this.loading = false;
      this.resetCaptcha();
      if (!response.success && this.register) {
        this.isVisible = true;
        this.isSuccess = false;
        this.registerMessage = response.error;
        return;
      }
      if (!response.success && !this.register) {
        this.alertDialog = {
          show: true,
          message: response.error,
          error: true,
          title: 'Error'
        }
        return;
      }
      if (response?.data?.token && response?.data?.tokenRefresh) {
        // Save token in localStorage
        this.dataLayer('web') // In register -> Send dataLayer 
        this.$store.dispatch('login', 
          { token: response.data.token, 
            tokenRefresh: response.data.tokenRefresh})
        this.$store.dispatch('profileComplete', response.data.profileComplete)
        if (!response.data.profileComplete || this.user.status != 'ACTIVE' || !this.user.client) {
          this.register ? this.$router.push({ name: "profile", params: { isRegister: true } })
            : this.$router.push("/profile")
        } else {
          localStorage.setItem('loginNow', 'true');
          this.$router.push("/home");
        }
      } else {
        this.alertDialog = {
          show: true,
          message: 'Error al autenticarse',
          error: true,
          title: 'Error'
        }
      }

    },
    resetCaptcha() {
      this.captcha.value = null;
      this.captcha.error = false;
      if (window.grecaptcha) window.grecaptcha.reset(this.captcha.id);
    },
    onVerify(value) {
      this.captcha.value = value;
      this.captcha.error = false;
    },
    onRender(id) {
      this.captcha.id = id;
    },
    onExpired() {
      this.captcha.error = true;
    },
    toggleRegister() {
      this.$refs.form.reset();
      this.register = !this.register;
    },
    closeModalRegister(){
      this.isVisible = false
    },
    dataLayer(app){
      if (this.register && this.dataSend && this.dataSend.name){
        window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'Register 1 Falkon',
            'eventLabel': app,
            'dataname': window.btoa(this.dataSend.name),
            'step': '1',
          });
      }
    },
  },
};
</script>

<style scoped>
.main-card {
  max-width: 506px;
}
.title-login {
  width: 100%;
  text-align: center;
  color: #FFFFFF;
  /* #fecf36 */
  font-size: 25pt;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.4rem;
}

.card-text-auth {
  background: #f5f5f5;
}

.letter-spacing {
  letter-spacing: 0.1rem;
}

.background-tcc {
  background: #CECECE;
  background-image: url('https://storage.googleapis.com/wp-bucket-tcc/falkon-admin/backgrounds/background.webp');
}

.label-register {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.label-pointer {
  text-align: center;
}

.label-forgot-password {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.anchor-text {
  cursor: pointer;
}
</style>

<!-- For Recpatcha iframe -->
<style>
iframe[title="reCAPTCHA"] {
  max-width: 100%;
}
</style>

<style scoped lang="scss">
  .check-terms {
    position: relative;
    cursor: pointer;
    .overlay-checkbox {
      width: 104%;
      height: 100%;
      position: absolute;
    }
    strong {
      color: $c3;
    }
  }
</style>

<style lang="scss" scoped>
@import "../../scss/login-register-forms.scss";
</style>
